import { Component, OnDestroy, OnInit } from "@angular/core";
import { ModalService } from "../../../../core-ui";

@Component({
  selector: "av-modal-container",
  templateUrl: "./modal-container.component.html",
  styleUrls: ["./modal-container.component.scss"],
})
export class ModalContainerComponent implements OnInit, OnDestroy {
  constructor(private modalService: ModalService) {}

  ngOnInit(): void {
    this.modalService.setVisibility(true);
  }

  ngOnDestroy(): void {
    this.modalService.setVisibility(false);
  }
}
